import { useEffect, useRef } from 'react';
import { useAuthStore } from '../stores';
import { markRT3Presence } from './useRT3Presence';

const ACTIVITY_THROTTLE_MS = 60_000;

export function useActivityHeartbeat() {
  const selfId = useAuthStore(s => s.currentUser?.id);
  const lastRef = useRef(0);

  useEffect(() => {
    if (!selfId) return;
    const onActivity = () => {
      const now = Date.now();
      if (now - lastRef.current < ACTIVITY_THROTTLE_MS) return;
      lastRef.current = now;
      markRT3Presence(selfId, 'online', undefined);
    };
    const events = ['keydown', 'mousedown', 'touchstart', 'scroll', 'focus'] as const;
    events.forEach(e => document.addEventListener(e, onActivity, { passive: true }));
    onActivity();
    return () => {
      events.forEach(e => document.removeEventListener(e, onActivity));
    };
  }, [selfId]);
}
